import { useEffect } from 'react';
import Highcharts from 'highcharts';
import Tree from 'highcharts/modules/treemap';
import exporting from 'highcharts/modules/exporting';
import data from 'highcharts/modules/data';
import Heatmap from 'highcharts/modules/heatmap';

Tree(Highcharts);
data(Highcharts);
Heatmap(Highcharts);
exporting(Highcharts);

const QAFollows = () => {
  const initialChart = () => {
    Highcharts.chart('QAFollows', {
      chart: {
        type: 'column',
      },

      title: {
        text: 'Follows',
      },

      xAxis: {
        type: 'category',
      },

      yAxis: {
        allowDecimals: true,
        min: 0,
        stackLabels: {
          enabled: true,
        },
        labels: {
          formatter: function () {
            return this.value;
          },
        },
        title: {
          text: null,
        },
      },

      credits: {
        enabled: false,
      },

      tooltip: { enabled: false },

      colors: ['#005cb1'],

      plotOptions: {
        column: {
          stacking: 'normal',
          groupPadding: 0,
          pointPadding: 0,
          shadow: false,
          borderWidth: 0,
        },
        series: {
          enableMouseTracking: false,
        },
      },

      series: [
        {
          name: 'Follows',
          data: [
            ['7 Oct', 100],
            ['8 Oct', 204],
            ['9 Oct', 85],
            ['10 Oct', 91],
            ['11 Oct', 44],
            ['12 Oct', 111],
            ['13 Oct', 99],
          ],
        },
      ],
    });
  };

  useEffect(() => {
    initialChart();
  }, []);

  return <div id="QAFollows" className="col-lg-3" />;
};

export default QAFollows;
